import { FC, useState } from 'react';
import { Button, Icon, Modal, ModalProps } from 'semantic-ui-react';

interface Props extends ModalProps {
    file?: { name: string, content: string };
    onClose: () => void;
}


const FileWindow: FC<Props> = (props) => {
    if (props.file === undefined) {
        return <div></div>;
    }

    const { file, onClose, ...modalProps } = props;
    const { name, content } = file;

    const saveFile = () => {
        const bytesNums = new Array(content.length);
        for (let i = 0; i < content.length; i++) {
            bytesNums[i] = content.charCodeAt(i);
        }
        const byteArray = new Uint8Array(bytesNums);
        const url = window.URL.createObjectURL(new Blob([byteArray]));
        const link = document.createElement('a');

        link.href = url;
        link.setAttribute('download', name);
        document.body.appendChild(link);
        link.click();
        link.parentNode?.removeChild(link);
    };

    return (
        <Modal
            size='large'
            style={{ minWidth: '70%', maxWidth: '95%' }}
            closeIcon
            open={true}
            {...modalProps}
            onClose={onClose}
        >
            <Modal.Header>{name}</Modal.Header>
            <Modal.Content scrolling>
                <Modal.Description>
                    <pre style={{ overflow: 'overlay'}}>{content}</pre>
                </Modal.Description>
            </Modal.Content>
            <Modal.Actions>
                <Button
                    circular
                    icon
                    labelPosition='left'
                    color='teal'
                    onClick={saveFile}
                >
                    <Icon name='save' />
                    Save
                </Button>
                <Button circular onClick={onClose}>
                    Close
                </Button>
            </Modal.Actions>
        </Modal>
  )
}

export default FileWindow;